// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "5642a6f81789f38dfef0bb73e24ece87" + ".css";
};